import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import fieldStateEnum from '@src/utils/enums/fieldStateEnum';

class SbValidatorField {
  constructor({ on, validations, message, showValidation, valid }) {
    this.on = on;
    this.validations = validations;
    this.valid = valid;
    this.showValidation = showValidation;
    this.message = message;
  }
}

export class SbValidator {
  constructor(config = {}) {
    this.setupValidator(config);
  }

  get valid() {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in this.validations) {
      if (!this.validations[key].valid) return false;
    }
    return true;
  }

  setupValidator(config) {
    // eslint-disable-next-line no-underscore-dangle
    this.on = this._validateAndGetOnState(config.on);
    // eslint-disable-next-line no-underscore-dangle
    this.validations = this._validateAndGetValidations(config.validations);
    this.validateImmediate = !!config.validateImmediate;
    this.messages = config.messages;
  }

  validate(key, val, formFields) {
    const validationObj = cloneDeep(this.validations[key]);
    const state = validationObj.on || this.on;
    if (val.state === state) validationObj.showValidation = true;
    let isValid = true;
    let validationMessage = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < validationObj.validations.length; i++) {
      const validationObject = validationObj.validations[i];
      const func = validationObject.function;
      const valid = func(val.value, formFields);
      isValid = valid;
      const messageObj = this.messages[validationObject.messageKey];
      if (typeof messageObj === 'object') validationMessage = isValid ? messageObj.valid : messageObj.invalid;
      else if (typeof messageObj === 'string') validationMessage = messageObj;
      else validationMessage = '';
      if (!isValid) break;
    }
    validationObj.valid = isValid;
    validationObj.message = validationMessage;
    return validationObj;
  }

  hasValidationFor(key) {
    return !!this.validations[key];
  }

  _validateAndGetOnState(state) {
    if (!state) return fieldStateEnum.submit;
    const states = Object.values(fieldStateEnum);
    const statesString = states.join('|');
    const regex = new RegExp(`(${statesString})`);
    const validState = state.match(regex);
    if (!validState) {
      console.warn(`Validator ON states must be one of: (${statesString})`) // eslint-disable-line
    }
    return validState ? state : fieldStateEnum.submit;
  }

  _validateAndGetValidations(validations) {
    const validationMap = {};
    if (!validations) {
      return validationMap;
    } else if (isEmpty(validations)) {
      console.warn('Provide a list of field configs to validate.') // eslint-disable-line
      return validationMap;
    }
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in validations) {
      // eslint-disable-next-line no-underscore-dangle
      validationMap[key] = this._validateAndGetValidation(key, validations[key]);
    }
    return validationMap;
  }

  _validateAndGetValidation(key, validation) {
    const { on, validate, valid, message, showValidation } = validation;
    // eslint-disable-next-line no-underscore-dangle
    const onState = this._validateAndGetOnState(on || this.on);
    // eslint-disable-next-line no-underscore-dangle
    const validationFuncs = this._validateAndGetFuncs(key, validate);
    return new SbValidatorField({
      valid,
      message,
      showValidation,
      on: onState,
      validations: validationFuncs,
    });
  }

  _validateAndGetFuncs(key, funcs) {
    if (!funcs) {
      return [];
    } else if (funcs.length === 0) {
      console.warn(`Please provide a list of functions to validate this field (${key}).`) // eslint-disable-line
      return [];
    }
    return funcs;
  }
}
